import { WEBSOCKET_RETRY_RATE_MS, MAX_WEBSOCKET_RETRY_RATE_MS } from './constants';

class RetryProvider {
  constructor(executor, defaultRetry = WEBSOCKET_RETRY_RATE_MS) {
    this.numAttempts = 0;
    this.executor = executor;
    this.hasActiveReconnection = false;
    this.defaultRetry = defaultRetry;
  }

  retry() {
    // Don't kickoff another reconnection attempt if we have one pending
    if (!this.hasActiveReconnection) {
      this.hasActiveReconnection = true;
      setTimeout(() => {
        this._execute();
      }, this._getDelay());
    }
  }

  _execute() {
    this.hasActiveReconnection = false;
    this.executor();
    this.numAttempts++;
  }

  connected() {
    this.numAttempts = 0;
  }

  _getDelay() {
    const calculatedDelay = Math.pow(2, this.numAttempts) * this.defaultRetry;
    return calculatedDelay <= MAX_WEBSOCKET_RETRY_RATE_MS ? calculatedDelay : MAX_WEBSOCKET_RETRY_RATE_MS;
  }

  getIsConnected() {
    return !this.numAttempts;
  }
}

export { RetryProvider };